// Routes des marchés municipaux et du domaine public (lot L2-C, partie B), raccordées dans
// Application.tsx par une seule ligne. Les chemins fixes précèdent la fiche /marches/:id.
import type { RouteObject } from 'react-router';
import { PageAttribution } from './PageAttribution';
import { PageAttributions } from './PageAttributions';
import { PageAutorisation } from './PageAutorisation';
import { PageDomainePublic } from './PageDomainePublic';
import { PageEmplacement } from './PageEmplacement';
import { PageMarche } from './PageMarche';
import { PageMarches } from './PageMarches';
import { PageNouvelleAttribution } from './PageNouvelleAttribution';
import { PageRecensement } from './PageRecensement';

export const routesMarches: RouteObject[] = [
  { path: '/marches', element: <PageMarches /> },
  { path: '/marches/attributions', element: <PageAttributions /> },
  { path: '/marches/attributions/nouvelle', element: <PageNouvelleAttribution /> },
  { path: '/marches/attributions/:id', element: <PageAttribution /> },
  { path: '/marches/emplacements/:id', element: <PageEmplacement /> },
  { path: '/marches/domaine-public', element: <PageDomainePublic /> },
  { path: '/marches/domaine-public/:id', element: <PageAutorisation /> },
  { path: '/marches/:id/recensement', element: <PageRecensement /> },
  { path: '/marches/:id', element: <PageMarche /> },
];
